import { hideElement } from "./openStorefront"
import { handleApplePayEvent } from "./applePayWrapper"

export function initPostMessageHandler() {
  window.addEventListener("message", (event) => {
    let container
    let content
    if (
      event.data &&
      event.data.type === "OneoLifecycleEvent" &&
      event.data.event
    ) {
      switch (event.data.event) {
        case "TrackCompleted":
          let iframe = getSourceIframe(event)
          if (iframe) {
            iframe.parentNode.removeChild(iframe)
          }
          break
        case "StorefrontMounted":
          if (
            (container = getSourceIframe(event).closest(".io-1o-Container"))
          ) {
            if (
              (content = container.querySelector(".io-1o-Container-content"))
            ) {
              if (container.style.display === "none") {
                container.removeChild(content)
              } else {
                content.style.opacity = 0
                content.style.boxShadow = "none"
                content.addEventListener("transitionend", () => {
                  container.removeChild(content)
                })
              }
            }
            container.querySelector("iframe").style.visibility = "visible"
          }
          break
        case "StorefrontClose":
          container = getSourceIframe(event).closest(".io-1o-Container")
          hideElement(container)
          if (container._1o_anchor) {
            container._1o_anchor.style.visibility =
              container._1o_previousAnchorVisibility
          }
          break
        case "StorefrontOrderFinished":
          container = getSourceIframe(event).closest(".io-1o-Container")
          container.isOrderFinished = true
          break
      }
    } else if (
      event.data &&
      event.data.type === "KatalysApplePayEvent" &&
      event.data.event
    ) {
      handleApplePayEvent(event)
    }
  })
}

export function getSourceIframe(event) {
  var iframes = document.getElementsByTagName("iframe")
  for (var i = 0, iframe, win; i < iframes.length; i++) {
    iframe = iframes[i]

    // Cross-browser way to get iframe's window object
    win = iframe.contentWindow || iframe.contentDocument.defaultView

    // Comparison
    if (win === event.source) {
      return iframe
    }
  }
}
